export const bodyTemp = {}